import { Component, Input, ViewChild } from '@angular/core'
import { AdobePDFViewerComponent } from '../adobe-pdf-viewer/adobe-pdf-viewer'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { PDFViewerComponent } from '../pdf-viewer/pdf-viewer.component'
import { NgTemplateOutlet, DatePipe } from '@angular/common'

@Component({
    selector: 'court-documents',
    templateUrl: './court-documents.html',
    imports: [
        NgTemplateOutlet,
        PDFViewerComponent,
        NgxBootstrapIconsModule,
        AdobePDFViewerComponent,
        DatePipe,
    ]
})
export class CourtDocumentsComponent {
    @ViewChild(AdobePDFViewerComponent) adobePDFViewerComponent: AdobePDFViewerComponent | undefined

    @Input('documents') set setDocuments(documents: any[]) {
        this.documents = structuredClone(documents)
        if (Array.isArray(documents) && documents.length) {
            this.documents.sort((a, b) => parseInt(a.docket_number) - parseInt(b.docket_number))
        }
    }
    @Input() colsDefn: string = "col-lg-12 col-xl-6"

    @Input() showHeader = true

    public documents: any[] = []

    public iconNames = IconNamesEnum

    unwrapJSONString(value:string) {
        if (value.indexOf('[') === 0) {
            value = value.substring(2, value.length - 2)
        }
        return value
    }
}